import { Instrument } from '@cash-web/protos/squareup/franklin/api/instrument.pb'

export const updateInstruments = ({
  instruments,
  newInstrument,
  tokenToReplace,
}: {
  instruments: ReadonlyArray<Instrument>
  newInstrument: Instrument & { token: NonNullable<Instrument['token']> }
  tokenToReplace?: string
}) => {
  let hasUpdated = false

  const newInstruments = instruments
    // If we're replacing a specific instrument, filter it out
    .filter(instrument => !tokenToReplace || instrument.token !== tokenToReplace)
    .map(instrument => {
      if (instrument.token === newInstrument.token) {
        hasUpdated = true

        return {
          ...newInstrument,
        }
      }

      return instrument
    })

  if (!hasUpdated) {
    newInstruments.push(newInstrument)
  }

  return newInstruments
}
